// Lib Imports
import React from 'react';
import { CaretUp, CaretDown } from '@styled-icons/boxicons-regular';
import PropTypes from 'prop-types';
import { classes } from '../utils';
export const SortIcons = ({
  column
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "rt-sort"
  }, /*#__PURE__*/React.createElement(CaretUp, {
    className: classes('rt-sort-asc', column.isSorted ? !column.isSortedDesc ? 'active' : 'inactive' : ''),
    size: "14px"
  }), /*#__PURE__*/React.createElement(CaretDown, {
    className: classes('rt-sort-desc', column.isSorted ? column.isSortedDesc ? 'active' : 'inactive' : ''),
    size: "14px"
  }));
};
SortIcons.propTypes = {
  column: PropTypes.object
};